import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import greaterThanIcon from "../../assets/icons/greaterthan.png";
import leftArrowIcon from "../../../public/assets/images/leftArrowIcon.png";
import ViceversaArrow from '../../components/ViceversaArrow';
import { truncateText } from "../../utils/utilFun";
import ExpensePopup from "./ExpensePopup";
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from "react-router-dom";
import {
  expenseApprovaldetails,
  expenseWisedetails,
  expenseSundrydetails,
  updateExpenseDetails,
  expenseApprovalDraft,
  expenseApprovalSubmit,
  expenseAttachment,
  clearSuccessMessage
} from '../../redux/slice/expenseApproval';
import {faCircleInfo,} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ErrorsPopup from '../sfc/ErrorsPopup';
import { useNavigate } from "react-router-dom";
import Successpop from "../stpfc/Successpop";
import Loader from '../../components/modal/Loader.jsx';
import Button from '../../components/button/Button';
import Popup from "../../components/Popup";
import { Tooltip } from "react-tooltip";
import excelIcon from '../../../public/assets/images/excelicon.png'
import ApprovalDetails from "./ApprovalDetails.jsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { managerLevelId } from "../../utils/Constant.js";

const ExpenseApprovaldetails = () => {
  const dispatch = useDispatch();
  const { expenseId } = useParams();
  const { isLoading,data,details,sundry,attachmentdata,successMessage} = useSelector((state) => state.expenseApproval);
  const sfcEmployeeData = useSelector((state) => state?.sfcUserBasicInfo)

  useEffect(() => {
    dispatch(expenseApprovaldetails());
    if (expenseId) {
      dispatch(expenseWisedetails(expenseId));
      dispatch(expenseSundrydetails(expenseId));
    }
  }, [dispatch, expenseId]);

  const [selectedEmployee, setSelectedEmployee] = useState(null);

  const handleOpenPopup = (item) => {
    setSelectedEmployee({
      Emp_id: employeeId,
      ActivityDate: item.date,
    });
  };

  const handleClosePopup = () => {
    setSelectedEmployee(null);
  };

const [expandedRow, setExpandedRow] = useState(null);

const handleRowClick = (index) => {
  setExpandedRow(expandedRow === index ? null : index);
};

const formatDate = (date) =>
  new Date(date).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });

const [showErrorPopup, setShowErrorPopup] = useState(false);
const [showPopupmsg, setShowPopupmsg] = useState(false);

const handleDeductionChange = (index, value) => {
  if (!/^\d*\.?\d*$/.test(value)) return;

  const totalSubmitted = Number(details[index]?.totalSubmitted) || 0;
  const approDedn = Number(value) || 0;
  let updatedDetails;
  if (approDedn > totalSubmitted) {
    setErrorMessage("Approval Value Cannot be more than Submitted/Previous approved value");
    setShowErrorPopup(true);
    updatedDetails = details.map((item, i) =>
      i === index ? { ...item, approDedn: "", approTotal: totalSubmitted } : item
    );
  } else {
    setErrorMessage("");
    setShowErrorPopup(false);

    updatedDetails = details.map((item, i) =>
      i === index ? { ...item, approDedn, approTotal: totalSubmitted - approDedn } : item
    );
  }

  dispatch(updateExpenseDetails(updatedDetails));
};

const handleCalculationChange = (index, name, value) => {
  if (!/^\d*\.?\d*$/.test(value)) return;

  let updatedDetails;

  if(name === 'staticTadaTotal') {
    const staticTadaTotal = Number(value) || 0
    updatedDetails = details?.map((item, i) =>
      i === index ? { ...item, staticTadaTotal } : item
    )
  } else if(name === 'staticOtherExpenseTotal') {
     const staticOtherExpenseTotal = Number(value) || 0
    updatedDetails = details?.map((item, i) =>
      i === index ? { ...item, staticOtherExpenseTotal } : item
    )
  } else if(name === 'staticMetroCharge') {
    const staticMetroCharge = Number(value) || 0
    updatedDetails = details?.map((item, i) =>
       ({ ...item, staticMetroCharge })
    )
  } else if(name === 'staticPhotoCopy') {
    const staticPhotoCopy = Number(value) || 0
    updatedDetails = details?.map((item, i) =>
      ({ ...item, staticPhotoCopy })
    )
  }
  dispatch(updateExpenseDetails(updatedDetails));
};

useEffect(() => {
  if(Array.isArray(details) && details?.length > 0) {
    const alreadySet = details[0]?.staticTadaTotal !== undefined;
    if (alreadySet) return;

    let updatedDetails = details?.map((item) => ({ ...item, staticTadaTotal: item?.tadaTotal , staticOtherExpenseTotal: item?.otherExpenseTotal, staticMetroCharge: item?.metroCharge, staticPhotoCopy: item?.photoCopy }))
    dispatch(updateExpenseDetails(updatedDetails));

  }
},[details])


const record = data.find(item => item.expenseId == expenseId);
const levelId = record?.level_id ;
const slNo = record?.slno;
const employeeId = record?.employeeId;
const expenseId1 = record?.expenseId;
const approverId=JSON.parse(localStorage.getItem("userData"))?.employeeId;


const navigate = useNavigate();

 const { isHospitalSurveyEnable } = JSON.parse(
      localStorage.getItem('userData')
    );

const handleClick = (item) => {
  if(isHospitalSurveyEnable) {
     navigate(`/expense-creation/${item.expenseDetailId}`, {
          state: {
            activityDateFor: item.date,
            expenseIdFor: item.expenseId,
            expenseDetailIdFor: item.expenseDetailId,
          },
        });
  } else {
    dispatch(expenseAttachment(employeeId, item.expenseDetailId, item.expenseId, item.date));
  localStorage.setItem(
    'SelectedExpenseData',
    JSON.stringify({
      employeeId: employeeId,
      expenseDetailId: item.expenseDetailId,
      expenseId: item.expenseId,
      activityDate: item.date,
      from: 'expense-details',
    })
  );
  navigate(`/my-expense-details/${item.expenseDetailId}`);
}
};


const [errorMessage, setErrorMessage] = useState("");
const [userDetails, setUserDetails] = useState({});

const handleApprovalAndRemarkChange = (e, id, type) => {
  const { value } = e.target;
  // Update the userDetails based on the type (status or remark)
  setUserDetails((prevDetails) => ({
    ...prevDetails,
    [id]: {
      ...prevDetails[id],
      [type]: value,
    },
  }));
};

useEffect(() => {
  if (!details || details.length === 0) return;
  const mapped = {};
  details.forEach((item) => {
    mapped[item.expenseDetailId] = {
      status: item.status === "U" ? "A" : item.status || "A",
      remark: item.status === "A" ? item.approveReason : item.rejectReason,
    };
  });

  setUserDetails(mapped);
}, [details]);


const handleSubmit = async () => {

  const draftDetails = details.map((item) => {
    const status = userDetails[item.expenseDetailId]?.status || "A";
    let remark = userDetails[item.expenseDetailId]?.remark || "";
    if (remark.trim() === "s") {
  remark = "";
}

    return {
      userId: approverId,
      approvalStatus: status,
      expenseId: expenseId1,
      reason:remark,
      activityDate:item.date,
      halfDay:item.halfDay,
      levelId: levelId,
      expenseSlno:item.expenseDetailId,
      approval1Remark:"",
      approval2Remark:"",
      adminRemark:"",
      expenseTotal: item.totalSubmitted-item.approDedn,
      expenseDetailId: item.expenseDetailId,
      approvalEntered: item.approDedn ?? 0,
      status:levelId,
      remarksForReject: status === "A" ? remark : "",
      rejectReasonWeb: status === "R" ? remark : "",
      adjOperator: "",
      processId:2,
      value:item.expenseId,
      approverId:approverId,
      statusNmae:Object.values(userDetails)?.some((e) => e.status === "R") ? "R" : status,
      remarks:remark,
      callPlanConfig:0,
      slNo:slNo,
      ...(Number(managerLevelId) === Number(data[0]?.level_id) && {
      adjustedTadaTotal: item?.staticTadaTotal,
      adjustedOtherExpenseTotal: item?.staticOtherExpenseTotal,
      adjustedMetroCharges: item?.staticMetroCharge,
      adjustedPhotoCopy: item?.staticPhotoCopy,
       }),
    };
  });

  const modifiedRecords = draftDetails.filter((item) => {
    return item.approvalStatus === "A" || item.approvalStatus === "R";
  });

  for (const item of modifiedRecords) {
    if (item.approvalStatus === "R" && (!item.rejectReasonWeb || item.rejectReasonWeb.trim() === "")) {
      setErrorMessage("Please give a valid reason for rejection");
      setShowErrorPopup(true);
      return;
    }
  }

  setIsSubmitting(true);

  try {
    await dispatch(expenseApprovalSubmit(modifiedRecords));
    setShowPopupmsg(true);
    setTimeout(() => {
      navigate("/expense-approval");
    }, 2000);


  } catch (error) {
    console.error("Error submitting drafts:", error);
    setErrorMessage("An error occurred while submitting data.");
    setShowErrorPopup(true);
  } finally {
    setIsSubmitting(false);
  }
};

const [isSubmitting, setIsSubmitting] = useState(false);


const handleSaveDraft = async () => {
  const draftDetails = details.map((item) => {
    const status = userDetails[item.expenseDetailId]?.status || "A";
    let remark = userDetails[item.expenseDetailId]?.remark || "";
    if (remark.trim() === "s") {
      remark = "";
    }

    return {
      expenseTotal: item.totalSubmitted-item.approDedn,
      expenseDetailId: item.expenseDetailId,
      approvalEntered: Number(item.approDedn ?? 0),
      status: Number(levelId),
      userId: Number(approverId),
      remarksForReject: status === "A" ? remark : "",
      approvalStatus: status,
      rejectReasonWeb: status === "R" ? remark : "",
      adjOperator: "A",
      expenseId: expenseId1,
      ActivityDate: item.date,
    };
  });

  const modifiedRecords = draftDetails.filter(
    (item) => item.approvalStatus === "A" || item.approvalStatus === "R"
  );

  for (const item of modifiedRecords) {
    if (
      item.approvalStatus === "R" &&
      (!item.rejectReasonWeb || item.rejectReasonWeb.trim() === "")
    ) {
      setErrorMessage("Please give a valid reason for rejection");
      setShowErrorPopup(true);
      return;
    }
  }

  setIsSubmitting(true);

  try {

    await dispatch(expenseApprovalDraft(modifiedRecords));
    setShowPopupmsg(true);
  } catch (error) {
    console.error("Error submitting drafts:", error);
    setErrorMessage("An error occurred while saving drafts.");
    setShowErrorPopup(true);
  } finally {
    setIsSubmitting(false);
  }
};

useEffect(() => {
  setShowPopupmsg(false);
}, []);

//Calculating the values Dynamically
const safeReduce = (arr, callback, initialValue) => (Array.isArray(arr) ? arr.reduce(callback, initialValue) : initialValue);

const totalFare = safeReduce(details, (sum, item) => sum + Number(item.fare || 0), 0);
const totalAllowance = safeReduce(details, (sum, item) => sum + Number(item.allownace || 0), 0);
const totalSubmitted = safeReduce(details, (sum, item) => sum + Number(item.totalSubmitted || 0), 0);
const totalApproDedn = safeReduce(details, (sum, item) => sum + Number(item.approDedn || 0), 0);

const Approve1Expense = safeReduce(details, (sum, item) => {
  const totalSubmitted = Number(item.totalSubmitted) || 0;
  const approDedn = Number(item.approDedn) || 0;
  const sundry = Number(item.sundry) || 0;
  return sum + (totalSubmitted - approDedn + sundry);
}, 0);

const totalSundry = safeReduce(sundry, (sum, item) => sum + Number(item.sundryTotal || 0), 0);

const totalexpense = totalSubmitted + totalSundry;
const finalApprovalExpense = safeReduce(
  sundry,(acc, item) => acc +Approve1Expense + Number(item.sundryTotal || 0),0);


  const handleExportToExcel = async () => {
      // Step 1: Calculate dynamic page height FIRST
const rowHeight = 5.5;
const headerHeight = sfcEmployeeData?.data ? 45 : 10;
const tableHeaderHeight = 10;
const summaryHeight = 28;
const approvedByHeight = 20;
const padding = 15;

const isLargeReport = details.length >= 1;

const dynamicHeight = headerHeight + tableHeaderHeight + (details.length * rowHeight) + summaryHeight + approvedByHeight + padding;
const pageHeight = Math.max(dynamicHeight, 180);

const doc = new jsPDF({
  unit: "mm",
  format: [297, pageHeight],
});

const pageWidth = doc.internal.pageSize.getWidth();

// ✅ Removed last column (26mm), redistributed to other columns to keep table wide
const mainTableWidth = 22 + 22 + 34 + 16 + 14 + 10 + 20 + 20 + 18 + 22 + 22 + 22 + 30; // = 250
const mainXCenter = (pageWidth - mainTableWidth) / 2;
const tableEndX = mainXCenter + mainTableWidth;

// Add employee details header — aligned to table width
if (sfcEmployeeData?.data) {
  const empData = sfcEmployeeData.data;

  doc.setFontSize(10);
  doc.setFont(undefined, 'bold');
  doc.text(`${data[0]?.companyName}`, mainXCenter, 12);

  doc.setFontSize(8);
  let yPosition = 19;

  const col1Label = mainXCenter;
  const col1Value = mainXCenter + 32;
  const col2Label = mainXCenter + 127;     // ✅ adjusted for new table width
  const col2Value = mainXCenter + 159;     // ✅ adjusted for new table width

  // Row 1
  doc.setFont(undefined, 'bold');
  doc.text("Employee Code:", col1Label, yPosition);
  doc.setFont(undefined, 'normal');
  doc.text(`${empData?.empCode || ''}`, col1Value, yPosition);

  doc.setFont(undefined, 'bold');
  doc.text("Employee Name:", col2Label, yPosition);
  doc.setFont(undefined, 'normal');
  doc.text(`${empData?.firstName || ''}`, col2Value, yPosition);
  yPosition += 5;

  // Row 2
  doc.setFont(undefined, 'bold');
  doc.text("Designation:", col1Label, yPosition);
  doc.setFont(undefined, 'normal');
  doc.text(`${empData?.designation || ''}`, col1Value, yPosition);

  doc.setFont(undefined, 'bold');
  doc.text("Month:", col2Label, yPosition);
  doc.setFont(undefined, 'normal');
  doc.text(`${empData?.expenseMonth ? new Date(empData?.expenseMonth).toLocaleString('default', { month: 'long' }) : '-'}`, col2Value, yPosition);
  yPosition += 5;

  // Row 3
  doc.setFont(undefined, 'bold');
  doc.text("Year:", col2Label, yPosition);
  doc.setFont(undefined, 'normal');
  doc.text(`${empData?.expenseYear ? empData?.expenseYear : '-'}`, col2Value, yPosition);


  doc.setFont(undefined, 'bold');
  doc.text("Team:", col1Label, yPosition);
  doc.setFont(undefined, 'normal');
  doc.text(`${empData?.teamName || ''}`, col1Value, yPosition);
  yPosition += 5;
}

// Main table
autoTable(doc, {
  head: [['Date', 'Activity', 'From-To City', 'Category', 'Dist(KM)', 'Way', 'Mode', 'Fare', 'Allowance', 'TADA Exp', 'TADA (Adj)' ,'OtherExp', 'Mgr Remarks']],
  body: [...details.map(item => [
    item?.date?.split("-")?.reverse()?.join("-"),
    item?.activity,
    `${item.fromTown}-${item.toTown}`,
    item?.stationType,
    `${item.distance}`,
    item.wayEntered === 'ONE WAY' ? "OW" : "TW",
    item.modeEntered,
    item?.fare,
    item.allownace,
    item?.tadaTotal,
    Number(item?.staticTadaTotal),
    item?.otherExpenseTotal,
    item?.rejectReason,
  ]),
  [
    '',
    '',
    '',
    '',
    '',
    '',
    'Total:',
    Array.isArray(details) && details?.reduce((a, c) => a + (c?.fare ?? 0), 0),
    Array.isArray(details) && details?.reduce((a, c) => a + (c?.allownace ?? 0), 0),
    Array.isArray(details) && details?.reduce((a, c) => a + (c?.tadaTotal ?? 0), 0),
    Array.isArray(details) && details?.reduce((a, c) => a + (c?.staticTadaTotal ?? 0), 0),
    Array.isArray(details) && details?.reduce((a, c) => a + (c?.tadaTotalotherExpenseTotal ?? 0), 0),
    ''
  ]],
  headStyles: {
    fillColor: [160, 77, 149],
    textColor: [0, 0, 0],
    fontStyle: 'bold',
    fontSize: 7,
  },
  styles: {
    cellPadding: 1.5,
    fontSize: 7,
    overflow: "linebreak",
    lineWidth: 0.2,
    lineColor: [180, 180, 180],
  },
  tableLineWidth: 0.3,
  tableLineColor: [100, 100, 100],
  bodyStyles: {
  fillColor: [255, 255, 255],
  textColor: [0, 0, 0],
  },
  alternateRowStyles: {
    fillColor: [255, 255, 255],
  },
  tableWidth: mainTableWidth,
  margin: { left: mainXCenter, right: mainXCenter, top: sfcEmployeeData?.data ? 38 : 8 },
  columnStyles: {
    0:  { cellWidth: 22 },
    1:  { cellWidth: 22 },
    2:  { cellWidth: 34 },
    3:  { cellWidth: 16 },
    4:  { cellWidth: 14 },
    5:  { cellWidth: 10 },
    6:  { cellWidth: 20 },
    7:  { cellWidth: 20 },
    8:  { cellWidth: 18 },
    9:  { cellWidth: 22 },
    10: { cellWidth: 22 },
    11: { cellWidth: 22 },
    12: { cellWidth: 30 },
  },
});

// ✅ Summary table — exactly same width and left margin as main table
const summaryColWidth = mainTableWidth / 6; // = 41.67 each, total = 250 ✅

autoTable(doc, {
  head: [['Expense Total', 'Other Expense', 'Metro Charges', 'Courier/Photo Copy', 'Local Conveyance', 'Grand Total']],
  body: [[
    Array.isArray(details) && details?.reduce((a, c) => a + (c?.tadaTotal ?? 0), 0),
    Array.isArray(details) && details?.reduce((a, c) => a + (c?.otherExpenseTotal ?? 0), 0),
    Array.isArray(details) && details[0]?.metroCharge,
    Array.isArray(details) && details[0]?.photoCopy,
    Array.isArray(details) && details[0]?.localConveyance,
    Array.isArray(details) && details?.reduce((a, c) => a + (c?.tadaTotal ?? 0) + (c?.otherExpenseTotal ?? 0), 0)
      + (details?.[0]?.metroCharge ?? 0)
      + (details?.[0]?.photoCopy ?? 0)
      + (details?.[0]?.localConveyance ?? 0)
  ]],
  startY: doc.lastAutoTable.finalY + 6,
  tableWidth: mainTableWidth,
  margin: { left: mainXCenter },
  styles: {
    cellPadding: 3,
    fontSize: 8,
    halign: 'center',
    valign: 'middle',
    lineWidth: 0.2,
    lineColor: [180, 180, 180],
  },
  tableLineWidth: 0.3,
  tableLineColor: [100, 100, 100],
  headStyles: {
    fontStyle: 'bold',
    fillColor: [160, 77, 149],
    textColor: [0, 0, 0],
    fontSize: 8,
  },
  bodyStyles: {
    fillColor: [240, 240, 240],
    textColor: [0, 0, 0],
  },
  columnStyles: {
    0: { cellWidth: summaryColWidth },
    1: { cellWidth: summaryColWidth },
    2: { cellWidth: summaryColWidth },
    3: { cellWidth: summaryColWidth },
    4: { cellWidth: summaryColWidth },
    5: { cellWidth: summaryColWidth },
  },
});

// ✅ Approved By — right aligned to table edge, signature line after text
const approvedByY = doc.lastAutoTable.finalY + 14;
const labelText = `Approved By: ${data[0]?.reportingToName}`;
const signText = "(Authorized Signatory)";

doc.setFontSize(8);
doc.setFont(undefined, 'bold');
doc.text(labelText, tableEndX - 60, approvedByY);

// ✅ Signature line starts AFTER "Approved By:" label with a small gap
const labelWidth = doc.getTextWidth(labelText);
const lineStartX = tableEndX - 60 + labelWidth + 3;
const lineEndX = tableEndX;

doc.setLineWidth(0.1);
doc.line(lineStartX, approvedByY, lineEndX, approvedByY);

doc.setFont(undefined, 'normal');
doc.setFontSize(7);
doc.text(signText, lineStartX, approvedByY + 4);

// =============================================
// SECTION: Generated Date & Time
// =============================================

const now = new Date();

const generatedDateTime = now.toLocaleString('en-IN', {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: true,
});

const footerY = doc.internal.pageSize.getHeight() - 8;

doc.setFontSize(7);
doc.setFont(undefined, 'normal');
doc.setTextColor(100, 100, 100);

doc.text(
  `Generated on: ${generatedDateTime}`,
  mainXCenter,
  footerY
);

// Restore text color
doc.setTextColor(0, 0, 0);

doc.save("expense-report.pdf");


  };


return (
    <div className="w-full flex flex-col bg-white lg:pt-16 lg:p-4 smAndMd:-pt-32 min-h-screen  ">

{isSubmitting && (
  <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center">
    <div className="w-12 h-12 border-4 border-t-transparent border-primary-150 rounded-full animate-spin"
    style={{ borderTopColor: '#A04D95' }}></div>
  </div>
)}

{/* your loader component or spinner */}
{showPopupmsg && (
        <Successpop
        displayText={successMessage}
          onClose={() => setShowPopupmsg(false)}
        />
      )}
 {/* Error Popup */}
 {showErrorPopup && (
        <ErrorsPopup
          show={showErrorPopup}
          message={errorMessage}
          onClose={() => setShowErrorPopup(false)}
        />
      )}

      <div className="flex justify-center items-center w-full h-10 relative p-4 lg:p-2 mt-20 mb-2 lg:mt-0 lg:mb-0 lg:flex lg:justify-start lg:items-center smAndMd:mt-6 smAndMd:mb-4 px-3 py-5">
        <Link to="/expense-approval" className="absolute  left-4 lg:left-0">
          <img src={leftArrowIcon} alt="leftIcon" height={"10px"} width={"10px"} />
        </Link>
        <p className="text-lg font-semibold text-center lg:ml-4 text-primary lg:text-baselg lg:font-semibold ">
          Expense Approval Details
        </p>
      </div>
      <div className="w-full h-[0.5px] bg-line-color"></div>

      {isHospitalSurveyEnable  ? <div className="flex justify-between items-center mt-4">
        <div className="text-[#514D4C] font-semibold text-lg">Approval</div>
        <div className="flex gap-2">
          <div className="text-[#A04D95] font-medium text-sm underline flex justify-center items-center cursor-pointer" onClick={() => {
            navigate('/other-expense', {
              state: {
                expenseId: expenseId
              }
            })
          }}>Expense Other</div>
          <div><img src={excelIcon} alt="excelIcon" width={24} height={24} onClick={handleExportToExcel}/></div>
        </div>
      </div> : null}



     {
      isHospitalSurveyEnable ? <ApprovalDetails details={details} userDetails={userDetails} expandedRow={expandedRow} handleRowClick ={handleRowClick} handleClick={handleClick} handleApprovalAndRemarkChange={handleApprovalAndRemarkChange} data={data} handleCalculationChange={handleCalculationChange}/> : <div className="mt-7">
        {/* Table Header for Desktop view*/}

       <div className="grid grid-cols-7 bg-gray-200 item-center flex-wrap rounded-t-md p-4 font-semibold text-xs text-center text-gray-700 smAndMd:hidden">
        <div className="col-span-1">Date</div>
        <div className="col-span-1 border-l border-gray-400">From City</div>
        <div className="col-span-1 border-l border-gray-400">To City</div>
        <div className="col-span-1 border-l border-gray-400">Fare</div>
        <div className="col-span-1 border-l border-gray-400">Total</div>
        <div className="col-span-1 border-l border-gray-400">Status</div>
        <div className="col-span-1 border-l border-gray-400">Approval Remarks </div>
      </div>

        {/* Table Body */}
        <div className="bg-white flex-wrap rounded-b-md border border-t-0 border-gray-300 smAndMd:hidden">
        {Array.isArray(details) && details.length > 0 && (details.map((item, index) => (
              <div key={index}>
                <div
                  className="grid grid-cols-8 items-center text-xs !text-center font-medium text-[#514D4C] p-3 -mb-2 -mt-1 truncate"
                >
                  <img
                    src={greaterThanIcon}
                    className={`cursor-pointer col-span-1 w-8 h-8 transform transition-transform -ml-2 ${expandedRow ===index ? "rotate-90" : "" }`} alt="toggle"
                    onClick={() => handleRowClick(index)}
                    data-tooltip-id="expand" data-tooltip-content={expandedRow===index ?'':'Expand'}
                  />
                  {/* <Tooltip id='expand' className="!text-xs !z-50 font-normal"/> */}
                  <div className="col-span-1 flex items-center -ml-24 text-primary cursor-pointer hover:underline font-semibold z-50"
                  onClick={() => handleClick(item)}
                  >
                  <span data-tooltip-id="navigate" data-tooltip-content='Navigate to Expense Details'>{formatDate(item.date)}</span>
                  <Tooltip id='navigate' className="!text-xs font-normal"/></div>
                  <div className="col-span-1 -ml-52 ">{item.fromTown}</div>
                  <div className="col-span-1 -ml-40">{item.toTown}</div>
                  <div className="col-span-1 -ml-32"><span>₹</span> {item.fare}</div>
                  <div className="col-span-1 -ml-20"><span>₹</span> {item.totalSubmitted}</div>
                  <div className="col-span-1 flex flex-col -ml-14 items-center justify-center cursor">
                    <label className="flex items-center space-x-1 cursor-pointer">
                    <input
                            className="accent-primary cursor-pointer"
                            type="radio"
                            value="A"
                            checked={userDetails[item.expenseDetailId]?.status === "A" || !userDetails[item.expenseDetailId]?.status}
                            onChange={(e) =>
                              handleApprovalAndRemarkChange(e, item.expenseDetailId, "status")
                            }
                            defaultChecked
                          />
                      <span>Approve</span>
                    </label>
                    <label className="flex items-center space-x-1 mt-2 -ml-3 cursor-pointer">
                    <input
                            className="accent-primary cursor-pointer"
                            type="radio"
                            value="R"
                            checked={userDetails[item.expenseDetailId]?.status === "R"}
                            onChange={(e) =>
                              handleApprovalAndRemarkChange(e, item.expenseDetailId, "status")
                            }
                          />
                      <span>Reject</span>
                    </label>
                  </div>
                  <div className="col-span-1 flex flex-col items-center justify-center">
                  <textarea
                        className=" border-gray-300 border-[0.5px] rounded-md -ml-4 p-1 text-xs h-10 w-full focus:outline-none focus:ring-1 focus:ring-[#A15CA4]"
                        name="remark"
                        value={userDetails[item.expenseDetailId]?.remark === 's' ? '' : userDetails[item.expenseDetailId]?.remark || ""}
                        onChange={(e) => handleApprovalAndRemarkChange(e, item.expenseDetailId, "remark")}
                      />
                  </div>
                </div>

                {index < details.length - 1 && <hr className="border-t border-gray-300 " />}

                {/* Expanded Row */}
                {expandedRow === index && (
                  <div className=" bg-gray-100 p-3 -mb-2">
                    <div className="grid grid-cols-8 text-xs items-center text-center font-semibold text-gray-700">
                      <div className="col-span-1 pr-10">Activity</div>
                      <div className="col-span-1 pr-10">Category</div>
                      <div className="col-span-1 pr-10">Fare</div>
                      <div className="col-span-1 pr-10">Distance</div>
                      <div className="col-span-1 pr-10">Allowance</div>
                      <div className="col-span-1 pr-10">Total Submitted</div>
                      <div className="col-span-1 pr-10">Approver Deduction</div>
                      <div className="col-span-1 pr-10">Approver Total</div>
                    </div>
                    <div className="w-full h-[0.5px] mt-2 mb-2 bg-line-color"></div>
                    <div className="grid grid-cols-8 py-2 text-xs text-center font-medium rounded-t-md text-[#514D4C]">

                    <div className="col-span-1 flex font-semibold text-primary " onClick={() => item.activity === "Field Work" && handleOpenPopup(item)}>
                      <span
                      className={item.activity === "Field Work" ? " text-primary  pr-1 cursor-pointer" : " text-black "}
                      >
                      {item.activity}
                      </span>
                      <span  data-tooltip-id="popup" data-tooltip-content='View more details'>
                      {item.activity === "Field Work" && (
                      <Popup color="#A04D95" />
                      )}
                      <Tooltip id="popup" className="!text-xs font-normal"/>
                      </span>
                    </div>
                      <div className="col-span-1 pr-10">{item.stationType}</div>
                      <div className="col-span-1 text-right pr-12"><span>₹</span> {item.fare}</div>
                      <div className="col-span-1 pr-10">{item.distance} <span>KM</span></div>
                      <div className="col-span-1 text-right pr-12"><span>₹</span> {item.allownace}</div>
                      <div className="col-span-1 text-right pr-10"><span>₹</span> {item.totalSubmitted}</div>

                      <div className="col-span-1 pr-10">
                      <input
                      type="text"
                      className="w-16 p-1 border border-gray-400 text-xs text-right rounded-md focus:outline-none focus:ring-1 focus:ring-[#A15CA4]"
                      value={item.approDedn ?? ""}
                      onChange={(e) => handleDeductionChange(index, e.target.value)}
                      disabled={item.totalSubmitted === 0}
                    />
                      </div>
                      <div className="col-span-1 text-right pr-10">
                      <span>₹</span> {item.totalSubmitted-item.approDedn}
                    </div>
                    </div>
                    {/* */}
                  </div>
                )}
              </div>
            ))
          )}

          {/* Final Total For Desktop Device */}
          <div className="grid grid-cols-6 text-xs bg-primary-100 p-3 mt-2 gap-2">
            <div className="row-span-2 flex items-center text-center pl-10 font-bold">Grand Total</div>

            <div className="text-center font-semibold text-gray-700">Fare</div>
            <div className="text-center font-semibold text-gray-700">Allowance</div>
            <div className="text-center font-semibold text-gray-700">Total Submitted</div>
            <div className="text-center font-semibold text-gray-700">Approval Deduction</div>
            <div className="text-center font-semibold text-gray-700">Approval Total</div>

            <div className="pr-10 font-bold text-right"><span>₹</span> {totalFare}</div>
            <div className="pr-12 font-bold text-right"><span>₹</span> {totalAllowance}</div>
            <div className="pr-7 font-bold text-right"><span>₹</span> {totalSubmitted}</div>
            <div className="pr-4 font-bold text-right"><span>₹</span> {totalApproDedn}</div>
            <div className="pr-8 font-bold text-right"><span>₹</span> {totalSubmitted - totalApproDedn}</div>
          </div>
        </div>


        {/* Table Body for Mobile device */}
        <div className="bg-white flex-wrap rounded-b-md border text-center border-t-0 -mt-6 border-gray-300  lg:hidden overflow-x-scroll ">
        {Array.isArray(details) && details.length > 0 && (details.map((item, index) => (
              <div key={index}>
                <div className="block pb-1 lg:hidden" >
                  <div className="w-full flex justify-between items-center">
                    <div className="flex items-center gap-4 mt-1 ml-2">
                      <p className="text-primary underline text-baseSm font-semibold"  onClick={() => handleClick(item)}>
                      {formatDate(item.date)}
                      </p>
                      </div>
                      <div className="flex items-center gap-4 mt-1 -mb-1" onClick={() => item.activity === "Field Work" && handleOpenPopup(item)}>
                      <span
                    className={item.activity === "Field Work" ? "cursor-pointer text-baseSm font-medium text-primary  -mr-2" : "text-baseSm font-medium"}
                  >
                    {item.activity}
                  </span>
                  {item.activity === "Field Work" && (
                    <Popup color="#A04D95" className="-ml-9" />
                  )}
                    </div>
                    <p className="text-primary text-baseSm mr-2 font-semibold">
                      {item.distance}KM
                    </p>
                  </div>
                  <div className="w-full flex justify-between items-center mt-2">
                    <div className="flex items-center gap-4 ">
                      <img
                        src={greaterThanIcon}
                        className={`w-8 h-8 transform transition-transform ${expandedRow ===index ? "rotate-90" : "" }`} alt="toggle"
                        onClick={() => handleRowClick(index)}
                        />
                      <p className="text-baseMd -ml-2 text-primary-black truncate">
                        {truncateText(item.fromTown, 10)}
                      </p>
                      <div className="flex font-semibold items-center justify-center">
                        <ViceversaArrow color="#79747E" />
                      </div>
                      <p className="text-baseMd text-primary-black truncate">
                        {truncateText(item.toTown, 10)}
                      </p>
                    </div>
                    <div className="lg:text-right lg:col-span-1 mr-2">
                      <p className="text-baseSm font-medium"><span>₹</span> {item.allownace}</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-4 ml-2">
                    <p className="text-lightGray text-baseSm font-medium">
                      {item.stationType}
                    </p>
                    <p
                      className="text-primary text-baseSm font-semibold ml-auto mr-2"
                      style={{ color: '#2FC23D' }}
                    >
                    Total Submitted: <span className="text-lightGray"><span>₹</span> {item.totalSubmitted}</span>
                    </p>
                  </div>
                </div>

                {index < details.length - 1 && <hr className="border-t border-gray-300" />}

        {/* Expanded Row */}
        {expandedRow === index && (
        <div className="border border-gray-100 rounded-sm pb-2 text-[14px] items-center text-gray-700">
          <p className="font-semibold shadow-sm text-left bg-primary-100 text-black pl-4 p-2">Total Approval Details</p>
          <div className="bg-gray-200 w-full h-[1px] px-2"></div>
          <div className="grid grid-cols-2 pt-2 text-[12px] my-1 pl-4 pr-4 text-gray-600">
            <p className="font-medium text-left">Fare </p>
            <p className="text-right"><span>₹</span> {item.fare}</p>
          </div>

          <div className="flex items-start justify-between text-[12px] my-1 pl-4 pr-4 text-gray-600 mt-1 mb-1 ">
            <p className="font-medium text-left">Approver Deduction </p>
            <input
              type="text"
              className="w-16 p-1 ml-16 border border-gray-400 text-xs text-right rounded-md focus:outline-none focus:ring-1 focus:ring-[#A15CA4]"
              value={item.approDedn ?? ""}
              onChange={(e) => handleDeductionChange(index, e.target.value)}
              disabled={item.totalSubmitted === 0}
            />
          </div>


          <div className="grid grid-cols-2 gap-x-10 gap-y-3 text-[12px] my-1 pl-4 pr-4 text-gray-600">
            <p className="font-medium text-left">Approval Total </p>
            <p className="text-right"><span>₹</span> {item.totalSubmitted-item.approDedn}</p>
          </div>

          <div className="bg-gray-200 w-full h-[1px] mt-1 mb-1"></div>
          <div className="flex items-start justify-between text-[12px] my-1 pl-4 pr-4 text-gray-600 mt-1 mb-1 ">
            <p className="font-medium text-left">Status </p>
            <div className="flex gap-4 mt-1">
              <label className="flex items-center space-x-1">
                <input
                className="accent-primary"
                type="radio"
                value="A"
                checked={userDetails[item.expenseDetailId]?.status === "A" || !userDetails[item.expenseDetailId]?.status}
                onChange={(e) =>
                handleApprovalAndRemarkChange(e, item.expenseDetailId, "status")
                }
                defaultChecked/>
                <span>Approve</span>
              </label>
              <label className="flex items-center space-x-1">
                <input
                className="accent-primary"
                type="radio"
                value="R"
                checked={userDetails[item.expenseDetailId]?.status === "R"}
                onChange={(e) =>
                handleApprovalAndRemarkChange(e, item.expenseDetailId, "status")
                } />
                <span>Reject</span>
              </label>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-x-5 gap-y-3 text-[12px] my-1 pl-4 pr-4 pb-2 text-gray-600">
            <p className="font-medium text-left">Reason </p>
            <textarea className="border border-gray-200 rounded-md p-1 text-xs h-10 w-full focus:outline-none focus:ring-1 focus:ring-[#A15CA4]"
            name="remark"
           value={userDetails[item.expenseDetailId]?.remark === 's' ? '' : userDetails[item.expenseDetailId]?.remark || ""}
            onChange={(e) => handleApprovalAndRemarkChange(e, item.expenseDetailId, "remark")}
            ></textarea>
          </div>
        </div>
            )}
          </div>
        ))
      )}



        {/* Final Total For Mobile Device */}
          <div className="bg-primary-100 p-2 my-1 pl-4 pr-4 text-[14px] text-center">
            <h2 className="font-semibold text-left ">Grand Total</h2>
            </div>

            <div className="mt-2 grid grid-cols-2 gap-2 text-baseSm my-1 pl-4 pr-4 text-left">
            <p className="font-medium">Fare </p>
              <p className="text-right font-medium "><span>₹</span> {totalFare}</p>

              <p className="font-medium">Allowance </p>
              <p className="text-right font-medium"><span>₹</span> {totalAllowance}</p>

              <p className="font-medium">Total Submitted </p>
              <p className="text-right font-medium"><span>₹</span> {totalSubmitted}</p>

              <p className="font-medium">Approval Deduction </p>
              <p className="text-right font-medium"><span>₹</span> {totalApproDedn}</p>

              <p className="font-medium">Approval Total </p>
              <p className="text-right font-medium"><span>₹</span> {totalSubmitted - totalApproDedn}</p>
            </div>
        </div>

        {sundry.map((item) => (
        <div className="mt-5 px-4  smAndMd:bottom-0 smAndMd:left-0 smAndMd:right-0 smAndMd:bg-white  smAndMd:p-4 lg:relative">

          <h3 className="text-center text-baseSm font-semibold text-gray-700">
            Sundry Expense :<span className="font-bold"> {item.sundryTotal}</span>
          </h3>


          <div className="w-full flex flex-col items-center mt-2 text-baseSm">
            <div className="w-full max-w-md border border-gray-300 rounded-md">
              <div className="grid grid-cols-2 bg-primary-100 rounded-t-md text-gray-700 font-semibold  text-center py-2">
                <div className="border-r border-gray-300">Total Expense</div>
                <div>Approver Expense</div>
              </div>
              <div className="grid grid-cols-2 text-center py-3 font-bold  bg-white">
              <div>{totalexpense}</div>
              <div>{finalApprovalExpense}</div>
              </div>
            </div>

            <p className="text-red-600 text-baseSm mt-2 font-semibold text-center">
              * all values include Sundry Expense.
            </p>
          </div>
        </div>
        ))}
     </div>
     }



      <div className="flex justify-center p-3 items-center space-x-4 smAndMd:space-x-4 smAndMd:flex-row ">

        <Button
          label="Save Draft"
          btTextColor="text-primary"
          btBgColor="white"
          btHeight="h-10"
          btWidth="w-36"
          //onClick={handleSaveClick}
          onClick={handleSaveDraft}
        />
        <Button
          label="Submit"
          onClick={handleSubmit}
          btBgColor="bg-primary"
          btHeight="h-10"
          btWidth="w-36"
          btTextColor="text-white"
        />

      </div>
      {/* {selectedEmployee && (
        <ExpensePopup
          onClose={handleClosePopup}
          empId={selectedEmployee.Emp_id}
          activityDate={selectedEmployee.ActivityDate}
          data={selectedEmployee} />)
          } */}
    </div>
  );
};

export default ExpenseApprovaldetails;
